<template>
    <div class="log_wrap">
        <div :class="{'hint flex aic':true,'hint2':isFinish}">
            <img v-if="isFinish" src="~@/assets/images/archives/dossier/select_icon.png" alt="">
            <img v-else src="~@/assets/images/archives/dossier/select_icon_not.png" alt="">
            项目全部验收合格，竣工效果图完成，成功交付客户
        </div>
        <div v-if="nTodonum > 0" class="todo_top">
            <!-- <div v-if="nTodonum > 0" :class="{'todo_top':true,'todo_unfold':isUnfoldTodo}">-->
            <p>项目待办清单</p>
            <!--  <img src="~@/assets/images/archives/dossier/todo_icon.png" alt="">-->
        </div>
        <div v-if="nTodonum > 0" ref="todo"
             :class="{'todo_list':true,'todo_list2':nTodonum > 3,'todo_unfold':isUnfoldTodo}">
            <template v-for="(item,index) in objTodoInfo">
                <div v-if="item.list && item.list.length > 0" class="todo_item">
                    <div v-if="item.img" class="todo_title flex aic">
                        <img :src="item.img" alt="">
                        <p>{{ item.title }}</p>
                    </div>
                    <div v-for="(item2,index2) in item.list" class="todo_step">
                        <div class="todo_msg">
                            {{ item2 }}
                        </div>
                    </div>
                </div>
            </template>
            <div :class="{'unfold_box':true,'unfold_box2':nTodonum > 3}">
                <img @click="touchUnfoldTodo"
                     src="~@/assets/images/archives/dossier/todo_unfold_icon.png"
                     alt="">
            </div>
        </div>
        <div class="log_list">
            <template v-for="(item,index) in objLogInfo">
                <div v-if="item.list && item.list.length > 0" class="log_item">
                    <div class="log_title flex aic">
                        <img :src="item.img" alt="">
                        <p>{{ item.title }}</p>
                    </div>
                    <div v-for="(item2,index2) in item.list" class="log_step">
                        <div class="log_msg">
                            {{ item2.text }}
                            <span @click="touchLog(item.key,item2)">
                                {{ item2.href_text }}
                            </span>
                            {{ item2.end_text }}
                        </div>
                        <div v-if="item2.type" class="log_msg">变更后项目类型：{{ item2.type }}</div>
                        <div v-if="item2.money" class="log_msg">变更后合同金额：{{ item2.money }}</div>
                        <div class="log_time">{{ item2.time }}</div>
                    </div>
                </div>
            </template>
        </div>
        <div class="bottom_btns flex aic jue">
            <!--            <button>动销上报</button>-->
        </div>
    </div>
</template>

<script>
import {ImagePreview} from "vant";
import {getLogInfo} from "@/js/archives/dossier.js";

export default {
    name: "DossierLog",
    data() {
        return {
            arrLogTitle: {
                change: {
                    title: '项目变更',
                    img: require('/src/assets/images/archives/dossier/setp_change.png')
                },
                contract: {
                    title: '签订合同',
                    img: require('/src/assets/images/archives/dossier/setp_contract.png')
                },
                design: {
                    title: '方案设计',
                    img: require('/src/assets/images/archives/dossier/setp_design.png')
                },
                follow: {
                    title: '潜客跟进',
                    img: require('/src/assets/images/archives/dossier/setp_follow.png')
                },
                work: {
                    title: '施工进度',
                    img: require('/src/assets/images/archives/dossier/setp_work.png')
                },
            },
            objLogInfo: [],
            objTodoInfo: [],
            isFinish: false,
            nTodonum: 0,
            isUnfoldTodo: false,
        }
    },
    watch: {
        '$route.query': {
            handler(newVal, oldVal) {
                this.getLogFun()
            }
        }
    },
    mounted() {
        this.getLogFun();
    },
    methods: {
        getLogFun() {
            this.$store.commit("loadSwitch", true);
            this.isFinish = false;
            this.objLogInfo = {};
            this.objTodoInfo = {};
            this.nTodonum = 0;
            getLogInfo({
                account_id: this.$route.query.account_id,
                project_id: this.$route.query.project_id,
                contract_id: this.$route.query.contract_id
            }).then((res) => {
                console.log('getLogInfo', res.data.data.result)

                let info = res.data.data.result;
                let objLogInfo = [];
                let objTodoInfo = [];
                info.forEach((item) => {
                    if (this.arrLogTitle.hasOwnProperty(item.key)) {
                        item.title = this.arrLogTitle[item.key].title;
                        item.img = this.arrLogTitle[item.key].img;
                        objLogInfo.push(item)
                    }
                    if (item.key == 'jg') {
                        this.isFinish = item.status == '1' ? true : false;
                    }
                    if (item.key == 'todo') {
                        let list = item.list;
                        for (const key in list) {
                            console.log(key, this.arrLogTitle.hasOwnProperty(key))
                            let item2 = {};
                            if (this.arrLogTitle.hasOwnProperty(key)) {
                                item2.key = key;
                                item2.title = this.arrLogTitle[key].title;
                                item2.img = this.arrLogTitle[key].img;
                                item2.list = list[key];
                                objTodoInfo.push(item2)
                            }
                            if (key == 'word') {
                                item2.key = key;
                                item2.list = list[key];
                                objTodoInfo.push(item2)
                            }
                        }
                        let nTodonum = 0;
                        objTodoInfo.forEach(it => {
                            nTodonum += it.list.length;
                        })
                        this.nTodonum = nTodonum;
                        if (this.nTodonum > 3) {
                            this.handleTodoHeight();
                        }
                    }
                })

                this.objLogInfo = objLogInfo;
                this.objTodoInfo = objTodoInfo;
                this.$store.commit("loadSwitch", false);
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
            })
        },
        handleTodoHeight() {

        },
        touchLog(key, item) {
            switch (key) {
                case 'contract':
                    if (item.contract_id) {
                        // type contract - 合同， change - 变更单
                        this.$router.push({
                            path: `/archives/contract`,
                            query: {type: key, contract_id: item.contract_id || '', change_id: item.change_id || ''}
                        })
                    } else {
                        ImagePreview({
                            images: item.img,
                            closeable: true,
                        })
                    }
                    break;
                case 'change':
                    // type contract - 合同， change - 变更单
                    this.$router.push({
                        path: `/archives/contract`,
                        query: {type: key, contract_id: item.contract_id || '', change_id: item.change_id || ''}
                    })
                    break;
                case 'work':
                    this.$router.push({
                        path: item.link_url,
                        query: {workorderId: item.new_workorder_id}
                    })
                    break;
                case 'design':
                    this.$router.push({
                        path: `/archives/design/details`,
                        query: {id: item.project_id, prog: item.project_design_id}
                    })
                    break;
                case 'follow':
                    if (item.follow_id) {
                        this.$router.push({
                            path: `/archives/followup`,
                            query: {id: item.follow_id}
                        })
                    } else if (item.url && item.url.length > 0) {
                        ImagePreview(item.url)
                    }
                    break;
            }
        },
        touchUnfoldTodo() {
            this.isUnfoldTodo = !this.isUnfoldTodo;
        }
    }
}
</script>

<style lang="scss" scoped>
.flex {
    display: flex;
}

.aic {
    align-items: center;
}

.aie {
    align-items: flex-end;
}

.juc {
    justify-content: center;
}

.jue {
    justify-content: flex-end;
}

.jusb {
    justify-content: space-between;
}

.fw {
    flex-wrap: wrap;
}

.fnw {
    flex-wrap: nowrap;
}

.log_wrap {
    width: 100%;
    background: #FFFFFF;
    margin-bottom: calc(128px + env(safe-area-inset-bottom));


    .hint {
        font-size: 24px;
        font-family: PingFang SC-Regular, PingFang SC;
        color: #CCCCCC;
        line-height: 28px;
        padding: 48px 0 64px;
        padding-left: 32px;

        img {
            width: 32px;
            height: 32px;
            display: block;
            margin-right: 16px;
        }
    }

    .hint2 {
        color: #24AE71;
    }

    .todo_top {
        padding: 0 54px 64px 64px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
            font-size: 26px;
            font-family: Acme-Regular, Acme;
            font-weight: 400;
            color: #0D53FC;
            line-height: 30px;
        }

        img {
            width: 64px;
            height: 64px;
            display: block;
            transform: rotate(180deg);
            transition: transform 0.2s;
        }
    }

    .todo_unfold {
        img {
            transform: rotate(0deg);
        }
    }

    .todo_list {
        height: fit-content;
        overflow-y: hidden;
        margin: 0 16px 66px;
        position: relative;
        border-bottom: 2px solid #EEEEEE;

        .todo_item {
            position: relative;
            padding-bottom: 32px;
        }

        .todo_item::after {
            content: "";
            position: absolute;
            top: 0;
            left: 22px;
            z-index: 0;
            width: 4px;
            height: 100%;
            background-image: linear-gradient(
                    #F5F5F5 0%,
                    #F5F5F5 50%,
                    transparent 50%
            );
            background-size: 100% 16px;
            background-repeat: repeat-y;
        }

        .todo_title {
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #3D3C4F;
            line-height: 28px;
            margin-bottom: 48px;

            img {
                width: 48px;
                height: 48px;
                display: block;
                margin-right: 16px;
                border-radius: 50%;
                position: relative;
                z-index: 5;
                filter: grayscale(100%);
            }
        }

        .todo_step {
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #3D3C4F;
            line-height: 32px;
            padding-left: 64px;
            padding-bottom: 48px;
            position: relative;
            z-index: 10;

            /*span {
                color: #0D53FC;
                border-bottom: 1px solid #0D53FC;
            }*/
        }

        .todo_step::after {
            content: "";
            position: absolute;
            top: 10px;
            left: 16px;
            z-index: 5;
            width: 16px;
            height: 16px;
            background: #939393;
            border-radius: 50%;
        }

        .todo_item:nth-last-child(2) {
            padding-bottom: 0px;

            .todo_step:nth-last-child(1) {
                background: linear-gradient(
                        transparent 0%,
                        transparent 20px,
                        #FFFFFF 20px
                );
                background-size: 100% 100%;
            }
        }

        .todo_msg {
            margin-bottom: 16px;
        }

        .todo_hint {
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #A3A3A3;
            line-height: 34px;
            margin-bottom: 16px;
        }

        .todo_time {
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #A3A3A3;
            line-height: 28px;
        }

        .unfold_box {
            position: absolute;
            width: 100%;
            z-index: 99;
            left: 0;
            bottom: 0;
            height: 0;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 80%);
            transition: height 0.2s;
            overflow-y: hidden;

            img {
                position: absolute;
                left: calc(50% - 15px);
                bottom: 54px;

                width: 30px;
                height: 30px;
                display: block;

                transition: transform 0.2s;
                transform: rotate(0deg);
            }
        }

        .unfold_box2{
            height: 300px;
        }
    }

    .todo_list2 {
        height: 450px;
    }

    .todo_unfold {
        height: fit-content;

        .unfold_box {
            position: relative;
            height: 100px;

            img {
                transform: rotate(180deg);
            }
        }
    }

    .log_list {
        padding: 0 16px 32px;

        .log_item {
            position: relative;
            padding-bottom: 32px;
        }

        .log_item::after {
            content: "";
            position: absolute;
            top: 0;
            left: 22px;
            z-index: 0;
            width: 4px;
            height: 100%;
            background-image: linear-gradient(
                    #F5F5F5 0%,
                    #F5F5F5 50%,
                    transparent 50%
            );
            background-size: 100% 16px;
            background-repeat: repeat-y;
        }

        .log_title {
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #3D3C4F;
            line-height: 28px;
            margin-bottom: 48px;

            img {
                width: 48px;
                height: 48px;
                display: block;
                margin-right: 16px;
                border-radius: 50%;
                position: relative;
                z-index: 5;
            }
        }

        .log_step {
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #3D3C4F;
            line-height: 32px;
            padding-left: 64px;
            padding-bottom: 48px;
            position: relative;
            z-index: 10;

            span {
                color: #0D53FC;
                border-bottom: 1px solid #0D53FC;
            }
        }

        .log_step::after {
            content: "";
            position: absolute;
            top: 10px;
            left: 16px;
            z-index: 5;
            width: 16px;
            height: 16px;
            background: #0D53FC;
            border-radius: 50%;
        }

        .log_item:nth-last-child(1) {
            padding-bottom: 0px;

            .log_step:nth-last-child(1) {
                background: linear-gradient(
                        transparent 0%,
                        transparent 20px,
                        #FFFFFF 20px
                );
                background-size: 100% 100%;
            }
        }

        .log_msg {
            margin-bottom: 16px;
        }

        .log_hint {
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #A3A3A3;
            line-height: 34px;
            margin-bottom: 16px;
        }

        .log_time {
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #A3A3A3;
            line-height: 28px;
        }
    }

    .bottom_btns {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 99;
        background: #FFFFFF;
        width: 100%;
        height: calc(112px + env(safe-area-inset-bottom));
        padding: 0 32px env(safe-area-inset-bottom);
        box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.03);

        button {
            width: 160px;
            height: 64px;
            background: #0D53FC;
            border-radius: 16px;
            font-size: 24px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 64px;
            text-align: center;
        }
    }
}
</style>
